import {
    GetEnumElementFromString,
    GetEnumNames,
    GetNextEnumValue,
    GetPreviousEnumValue,
} from "motw_core/Utils/EnumUtils";
import * as React from "react";
import { FormSelect } from "source/app/presentation/Shared/Form/Select/FormSelect";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { EEmotionRecordTimePeriod } from "./ShowEmotionValues";

export function ToggleEmotionValuesTimePeriod({
    timePeriod,
    setTimePeriod,
}: {
    timePeriod: EEmotionRecordTimePeriod;
    setTimePeriod: React.Dispatch<
        React.SetStateAction<EEmotionRecordTimePeriod>
    >;
}) {
    const currentEnumString = EEmotionRecordTimePeriod[timePeriod];

    const currentEnumValue = GetEnumElementFromString(
        EEmotionRecordTimePeriod,
        currentEnumString
    )!;

    return (
        <div
            style={{ position: `relative`, top: `25px`, paddingBottom: `25px` }}
        >
            <IconWithText
                iconSuffix={EGlyphicon["chevron-left"]}
                withClass={nextPreviousStyle}
                whenClicked={() => {
                    const prevEnumElement = GetPreviousEnumValue(
                        EEmotionRecordTimePeriod,
                        currentEnumValue
                    );

                    setTimePeriod(prevEnumElement);
                }}
                displayAsBlock={false}
            />
            <FormSelect
                id="selectTimePeriod"
                label="period"
                width="90px"
                suggestions={GetEnumNames(EEmotionRecordTimePeriod)}
                onChange={(event) => {
                    const enumElement = GetEnumElementFromString(
                        EEmotionRecordTimePeriod,
                        event.target.value
                    )!;

                    setTimePeriod(enumElement);
                }}
                hideEmptyOption
                value={currentEnumString}
            />
            <IconWithText
                iconSuffix={EGlyphicon["chevron-right"]}
                withClass={nextPreviousStyle}
                whenClicked={() => {
                    const prevEnumElement = GetNextEnumValue(
                        EEmotionRecordTimePeriod,
                        currentEnumValue
                    );

                    setTimePeriod(prevEnumElement);
                }}
                displayAsBlock={false}
            />
        </div>
    );
}

const nextPreviousStyle = StyleClassAuto({
    margin: "0px 10px",
    background: "#2c2c2c",
    color: "#ffffff",
    padding: "9px 6px 6px 6px",
    borderRadius: "5px",
    ":hover": {
        background: "#565656",
    }
});
